module.exports = __webpack_public_path__ + "img/headbg-1.36d2805c.png";